(function () {
  'use strict';

  if (window.__noodyPdpUi) return;
  window.__noodyPdpUi = true;

  var REVIEW_SECTION_IDS = ['17866717848341c194', '1742169430b6abb5e8'];

  function track(eventName, data) {
    var payload = { event: eventName };
    Object.keys(data || {}).forEach(function (key) { payload[key] = data[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function setupGallery(root) {
    var viewport = root.querySelector('[data-ndy-gallery-viewport]');
    if (!viewport || viewport.dataset.ndyInit === '1') return;
    viewport.dataset.ndyInit = '1';

    var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-ndy-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ndy-gallery-thumb]'));
    var previous = root.querySelector('[data-ndy-gallery-prev]');
    var next = root.querySelector('[data-ndy-gallery-next]');
    var counter = root.querySelector('[data-ndy-gallery-counter]');
    var cue = root.querySelector('[data-ndy-swipe-cue]');
    var activeIndex = 0;
    var frame = 0;
    var resizeTimer = 0;

    if (slides.length < 2) return;

    function hideCue() {
      if (cue) cue.classList.add('is-hidden');
    }

    function update(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (counter) counter.textContent = (activeIndex + 1) + ' / ' + slides.length;
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;

      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function goTo(index, smooth) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      update(index);
      viewport.scrollTo({
        left: slides[index].offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }

    function syncFromScroll() {
      frame = 0;
      update(Math.round(viewport.scrollLeft / (viewport.clientWidth || 1)));
      if (viewport.scrollLeft > 8) hideCue();
    }

    viewport.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });
    viewport.addEventListener('touchstart', hideCue, { passive: true });
    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') hideCue();
    }, { passive: true });
    viewport.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      hideCue();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    if (previous) previous.addEventListener('click', function () { hideCue(); goTo(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { hideCue(); goTo(activeIndex + 1); });
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { hideCue(); goTo(index); });
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { goTo(activeIndex, false); }, 100);
    }, { passive: true });

    update(0);
  }

  function findReviewSection() {
    var section = null;
    REVIEW_SECTION_IDS.some(function (id) {
      section = document.querySelector('[id*="' + id + '"]');
      return Boolean(section);
    });
    if (section) return section;

    var widget = document.querySelector('.jdgm-review-widget');
    return widget && (widget.closest('[id^="shopify-section-"]') || widget.closest('.shopify-section') || widget);
  }

  function mountReviews(root) {
    var slot = root.querySelector('[data-ndy-reviews-slot]');
    if (!slot || slot.dataset.ndyMounted === '1') return Boolean(slot && slot.dataset.ndyMounted === '1');

    var section = findReviewSection();
    if (!section || slot.contains(section)) return false;

    var loading = slot.querySelector('[data-ndy-reviews-loading]');
    if (loading) loading.remove();
    section.hidden = false;
    section.style.display = '';
    section.classList.add('ndy-pareto__review-section');
    slot.appendChild(section);
    slot.dataset.ndyMounted = '1';
    window.setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60);
    return true;
  }

  function setupAccordions(root) {
    var stack = root.querySelector('[data-ndy-pareto]');
    if (!stack || stack.dataset.ndyInit === '1') return;
    stack.dataset.ndyInit = '1';

    var items = Array.prototype.slice.call(stack.children).filter(function (node) {
      return node.matches && node.matches('details.ndy-pareto__item');
    });

    function ensureReviews() {
      if (mountReviews(root) || root.__ndyReviewObserver || !window.MutationObserver) return;
      var observer = new MutationObserver(function () {
        if (mountReviews(root)) {
          observer.disconnect();
          root.__ndyReviewObserver = null;
        }
      });
      root.__ndyReviewObserver = observer;
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () {
        observer.disconnect();
        if (root.__ndyReviewObserver === observer) root.__ndyReviewObserver = null;
      }, 5000);
    }

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
        track('noody_pdp_accordion_opened', {
          product_handle: root.dataset.productHandle || '',
          accordion: (item.querySelector(':scope > summary > span') || {}).textContent || ''
        });
        if (item.hasAttribute('data-ndy-reviews')) ensureReviews();
      });
    });

    stack.querySelectorAll('.ndy-pareto__faq').forEach(function (faq) {
      faq.addEventListener('toggle', function () {
        if (!faq.open) return;
        stack.querySelectorAll('.ndy-pareto__faq[open]').forEach(function (other) {
          if (other !== faq) other.open = false;
        });
      });
    });

    var reviewLink = root.querySelector('[data-ndy-open-reviews]');
    var reviewDetails = root.querySelector('[data-ndy-reviews]');
    if (reviewLink && reviewDetails) {
      reviewLink.addEventListener('click', function (event) {
        event.preventDefault();
        reviewDetails.open = true;
        ensureReviews();
        reviewDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function init(root) {
    if (!root || root.dataset.ndyUiInit === '1') return;
    root.dataset.ndyUiInit = '1';
    setupGallery(root);
    setupAccordions(root);
  }

  function start() {
    document.querySelectorAll('[data-ndy-core-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
